module.exports = __webpack_public_path__ + "img/bayer_back_body.92bfe8ba.jpg";